export const IG_LINK = "https://www.instagram.com/calume_cafe/"
export const FB_LINK = "https://www.facebook.com/calumecafe"

export const LOGO_SRC = "logo.jpg"

export const CAROUSEL_IMAGES = ["store-out.jpeg"]

export const BACKGROUND_IMAGE = "background-beans.jpg"